module.exports = __webpack_public_path__ + "img/email-btn.a41ff311.svg";